export const isAdminPort2PortOrStation2StationRoute = () => (
    window?.currentRoute === 'admin_station_to_station_widget_permalink_preview'
    || window?.currentRoute === 'admin_port_to_port_widget_permalink_preview'
)
